export default function Spinner() {
  return (
    <div className="spinner ease-linear rounded-full border-4 border-t-4 border-gray-200 mb-4"></div>
  );
}
